"use client"

import type { Student } from "../../../../lib/students-data"
import { ReportTableRow } from "./report-table-row"
import { PaginationStats } from "../students-management/pagination-stats"

interface ReportTableProps {
  students: Student[]
  selectedIds: string[]
  onSelectAll: (checked: boolean) => void
  onSelect: (id: string) => void
  onViewDetails: (student: Student) => void
  onUpload: (id: string) => void
  onDelete: (id: string) => void
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
}

export function ReportTable({
  students,
  selectedIds,
  onSelectAll,
  onSelect,
  onViewDetails,
  onUpload,
  onDelete,
  currentPage,
  totalPages,
  onPageChange,
}: ReportTableProps) {
  const resultsPerPage = 10
  const totalResults = students.length * totalPages
  const allSelected = students.length > 0 && students.every((s) => selectedIds.includes(s.id))

  return (
    <div className="bg-card rounded-xl shadow-lg border border-border overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-muted border-b border-border">
              <th className="p-5 w-12">
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={(e) => onSelectAll(e.target.checked)}
                  className="w-4 h-4 text-primary border-border rounded focus:ring-primary cursor-pointer"
                />
              </th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase">Student Name</th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase">Class</th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase">Parent Email</th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase">Overall Grade</th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase">Subjects</th>
              <th className="p-5 text-sm font-semibold tracking-wide text-muted-foreground uppercase text-right">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {students.map((student) => (
              <ReportTableRow
                key={student.id}
                student={student}
                isSelected={selectedIds.includes(student.id)}
                onSelect={onSelect}
                onViewDetails={onViewDetails}
                onUpload={onUpload}
                onDelete={onDelete}
              />
            ))}
          </tbody>
        </table>
      </div>
      <div className="px-5 py-4 border-t border-border">
        <PaginationStats
          currentPage={currentPage}
          totalPages={totalPages}
          totalResults={totalResults}
          resultsPerPage={resultsPerPage}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  )
}
